import { type FunctionComponent } from 'react';
import { MEDALLIA_FERGHOME_FORM_ID } from '../../../constants/medallia';
import { useMedallia } from '../../../hooks/medallia/medallia.hooks';
import { TextButton, type TextButtonProps } from '../text-button/text-button.component';

type MedalliaButtonProps = Pick<TextButtonProps, 'color' | 'underline'>;

export const MedalliaButton: FunctionComponent<MedalliaButtonProps> = ({ color = 'white', underline }) => {
	const { openMedalliaForm, isMedalliaLoaded } = useMedallia(MEDALLIA_FERGHOME_FORM_ID);
	return (
		<TextButton color={color} underline={underline} underlineHover={true} onClick={openMedalliaForm} disabled={!isMedalliaLoaded}>
			Feedback
		</TextButton>
	);
};
